import { PRESENTATION_MODE_EVENTS } from '@/content/values/ed-presentation-mode.values';
import { DISCONNECTED_SOCKET_EVENT } from '@/core/values/app.values';
import { MEETINGS_STORE } from '@/meetings/store/meetings.store';
import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class EdPresentationModeNavigationToggle extends Vue {
  
  public switchToggle : boolean = true;
  public switchToggleTitle : string = 'On';
  private navigationValues : { [key: string]: string } = {};

  get isPresentationNavigation() : boolean {
    return this.$store.state.MeetingsStore.isPresentationNavigation;
  }

  get navigationLabel(): string {
    return `${this.$t('meetings.presentationMode.navigation')}`
  }

  public onChangeNavigation() : void {
    this.switchToggleTitle = this.navigationValues[this.switchToggle.toString()];
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_NAVIGATION, this.switchToggle);
    if(this.switchToggle){
      this.$edEventBus.$emit(PRESENTATION_MODE_EVENTS.SEND_PENDING_MESSAGES);
    }
  }
  
  private buildValues() : void {
    this.navigationValues = {
      true: `${this.$t('meetings.presentationMode.off')}`,
      false: `${this.$t('meetings.presentationMode.on')}`
    };
  }

  private setInitialValues() : void {
    this.switchToggleTitle = this.navigationValues[this.switchToggle.toString()];
    this.switchToggle = this.isPresentationNavigation;
  }

  private restoreSwitchToggle(): void {
    if(this.switchToggle){
      return;
    }
    this.switchToggle = true;
    this.switchToggleTitle = this.navigationValues[this.switchToggle.toString()];
    this.$store.commit(MEETINGS_STORE.MUTATIONS.UPDATE_PRESENTATION_NAVIGATION, this.switchToggle);
  }

  activated() {
    this.switchToggle = this.isPresentationNavigation;
  }

  mounted() {
    this.buildValues();
    this.setInitialValues();
    this.$edEventBus.$on(DISCONNECTED_SOCKET_EVENT, this.restoreSwitchToggle);
  }

  beforeDestroy() {
    this.$edEventBus.$off(DISCONNECTED_SOCKET_EVENT, this.restoreSwitchToggle);
  }

}